import {useMemo} from 'react';
import {useGetUserQuery} from 'modules/user/services';

export const useIsPrive = () => {
    const {data: user} = useGetUserQuery();
    return useMemo<boolean>(() => 'prive' === user?.userGroupName, [user?.userGroupName]);
};
